<template>
  <div
    :key="widgetType"
    class="h-100 w-100 d-flex align-center justify-center flex-column pa-6"
    data-testid="widget-error-state"
  >
    <v-icon :icon="icon" size="80"></v-icon>
    <span class="subtitle1 mb-4 text-center">
      {{ title ?? $t(`dashboard.widgets.${widgetType}.error`) }}</span
    >
    <div class="coro-link" @click="$emit('retry-click')">
      {{ $t("general.retry") }}
    </div>
  </div>
</template>
<script lang="ts">
import type { PropType } from "vue";
import type { WidgetType } from "@/constants/dashboard.ts";

export default {
  props: {
    widgetType: {
      type: String as PropType<WidgetType | string>,
      required: true,
    },
    icon: {
      type: String,
      default: "$alertTriangle",
    },
    title: {
      type: String,
      required: false,
    },
  },
  emits: ["retry-click"],
};
</script>
